import { launchNativeGoogleOauth2Flow } from "common/native-hooks";
import "twin.macro";
import { WireButton } from "webapp/ui/views/wire-button/wire-button";
import { UIButtonAppearance } from "wire/types";
import { getCredentials, getHTTPGoogleOAuth2RedirectURL } from "../../../../lib/common-google-api";
import { GoogleLogo } from "../../../../lib/google-logo";
import type { AuthProviderCallbacks, InteractionProps } from "./types";

export function WireGoogleAuthProviderButton(props: AuthProviderCallbacks & InteractionProps): JSX.Element {
    const { userAgreed } = props;

    return (
        <>
            <div tw="h-px bg-n100 mt-6 mb-6"></div>
            <WireButton
                tw="w-full mt-6 h-10"
                id={"sign-in-with-google-button"}
                disabled={!userAgreed}
                appearance={UIButtonAppearance.Bordered}
                onClick={async e => {
                    e.preventDefault();
                    // FIXME: This will need to be set on a per-app basis in the future.
                    const clientID = getCredentials().clientId;
                    if (await launchNativeGoogleOauth2Flow(clientID)) return;

                    props.createPopupForOAuth2Flow(getHTTPGoogleOAuth2RedirectURL);
                }}>
                <div tw="flex justify-center">
                    <GoogleLogo />
                    <label tw="ml-2.5" htmlFor={"sign-in-with-google-button"}>
                        {/* FIXME: Localize this */}
                        Continue with Google
                    </label>
                </div>
            </WireButton>
        </>
    );
}

export function WireGoogleSignInButton(props: InteractionProps): JSX.Element {
    const { userAgreed } = props;

    return (
        <>
            <div tw="h-px bg-n100 mt-6 mb-6"></div>
            <WireButton
                tw="w-full h-10"
                id={"sign-in-with-google-button"}
                appearance={UIButtonAppearance.Bordered}
                disabled={!userAgreed}>
                <div tw="flex justify-center">
                    <GoogleLogo />
                    <label tw="ml-2.5" htmlFor={"sign-in-with-google-button"}>
                        {/* FIXME: Localize this */}
                        Continue with Google
                    </label>
                </div>
            </WireButton>
        </>
    );
}
